<template>
    <div class="report-container">
        <div class="circle-decoration"></div>

        <header class="header-section">
            <h1 class="year-text">2026</h1>
            <h2 class="brand-name">富学宝典</h2>
            <div class="report-badge">半年度学习报告</div>
            <p class="slogan">坚持学习的人 · 永葆青春</p>
            <p class="slogan pc-only-hint">(请使用富学宝典APP扫码查看)</p>
        </header>
        <main v-show="false" class="main-content">
            <div class="input-group" :class="{ 'is-focused': isFocused }">
                <input class="job-input" placeholder="请输入工号" v-model="jobNo" @focus="isFocused = true"
                    @blur="isFocused = false" type="text">
                <div class="input-line"></div>
            </div>
            <button class="submit-btn" @click="debouncedSubmit" :disabled="!jobNo">
                <span>LET'S GO</span>

                <div class="btn-glow"></div>
            </button>
        </main>

        <footer class="footer-info" v-show="footerVisible">
            <p>版权所有：富泰华工业（深圳）有限公司</p>
            <p>备案号：<a href="https://beian.miit.gov.cn">粤ICP备13021698号</a></p>
        </footer>
    </div>
</template>

<script>
import jieliufa from '@/utils/jieliufa'

export default {
    data() {
        return {
            jobNo: '',
            isFocused: false,
            footerVisible: true,
            originalHeight: 0
        }
    },
    computed: {
        // 使用节流包装提交方法
        debouncedSubmit() {
            return jieliufa.throttle(() => {
                this.submitJobNo()
            }, 1000)
        }
    },
    mounted() {
        this.originalHeight = window.innerHeight;
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            // 兼容移动端键盘弹出遮挡
            this.footerVisible = window.innerHeight >= this.originalHeight - 100;
        },
        submitJobNo() {
            if (!this.jobNo.trim()) {
                this.$message({
                    message: "请输入工号",
                    type: "warning",
                    center: true
                })
                return
            }
            this.$emit('inputJobNo', this.jobNo)
        }
    }
}
</script>

<style scoped>
/* ==========================================================================
   1. 移动端/通用基础样式
   ========================================================================== */
.report-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    /* 移动端多背景无缝铺满 */
    background:
        linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
        url("../../assets/26June/logo.png") right top no-repeat,
        url("../../assets/26May/icon.png") 49% calc(80% + 20px) no-repeat,
        url("../../assets/26June/bg.jpg") no-repeat;
    background-size: cover, 110px 35px, 68%, cover;
    background-position: center, right top, 49% calc(80% + 20px), center;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.pc-only-hint {
    display: none;
}

/* 头部视觉 */
.header-section {
    margin-top: 14vh;
    text-align: center;
    z-index: 2;
    animation: fadeInDown 0.8s ease-out;
}

.year-text {
    font-size: 64px;
    font-weight: 900;
    color: #00bfa5;
    margin: 0;
    line-height: 1;
    /* font-family: 'Gentium Basic', Georgia, serif; */
    letter-spacing: 4px;
    text-shadow: 0 4px 20px rgba(0, 0, 0, 0.6);
}

.brand-name {
    font-size: 34px;
    font-weight: bold;
    color: #ffffff;
    margin: 12px 0;
    letter-spacing: 2px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.report-badge {
    display: inline-block;
    background: linear-gradient(135deg, #008777, #00bfa5);
    color: #ffffff;
    font-weight: 600;
    padding: 6px 28px;
    border-radius: 50px;
    font-size: 16px;
    letter-spacing: 1px;
    box-shadow: 0 4px 15px rgba(0, 191, 165, 0.4);
    margin: 15px 0;
}

.slogan {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.85);
    font-weight: 400;
    letter-spacing: 2px;
    text-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
}

/* 主体交互区 */
.main-content {
    width: 85%;
    max-width: 320px;
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
    animation: fadeInUp 0.8s ease-out;
}

.input-group {
    width: 100%;
    position: relative;
    margin-bottom: 35px;
    transition: all 0.3s ease;
}

.job-input {
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    padding: 16px;
    border-radius: 16px;
    font-size: 18px;
    text-align: center;
    outline: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    color: #ffffff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.job-input::placeholder {
    color: rgba(255, 255, 255, 0.5);
}

.input-line {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 3px;
    background: #00bfa5;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-50%);
    border-radius: 2px;
}

.input-group.is-focused .input-line {
    width: 90%;
}

.input-group.is-focused .job-input {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(0, 191, 165, 0.5);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 191, 165, 0.25);
}

.submit-btn {
    position: relative;
    width: 100%;
    padding: 15px 40px;
    border: none;
    background: linear-gradient(135deg, #008777, #00bfa5);
    color: #fff;
    border-radius: 16px;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 2px;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.3s;
    box-shadow: 0 6px 20px rgba(0, 135, 119, 0.4);
}

.submit-btn:hover:not(:disabled) {
    box-shadow: 0 8px 25px rgba(0, 191, 165, 0.6);
    transform: translateY(-1px);
}

.submit-btn:active:not(:disabled) {
    transform: scale(0.98);
}

.submit-btn:disabled {
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: none;
    cursor: not-allowed;
    color: rgba(255, 255, 255, 0.3);
}

.btn-glow {
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    animation: sweep 3.5s infinite;
}

@keyframes sweep {
    0% { left: -100%; }
    40% { left: 100%; }
    100% { left: 100%; }
}

@keyframes fadeInDown {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
}

.footer-info {
    position: fixed;
    bottom: 24px;
    text-align: center;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.6;
    z-index: 2;
}

.footer-info a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    padding-bottom: 1px;
    transition: all 0.3s;
}

.footer-info a:hover {
    color: #00bfa5;
    border-bottom-color: #00bfa5;
}


/* ==========================================================================
   2. PC端全屏高级响应式适配
   ========================================================================== */
@media screen and (min-width: 1024px) {
    .report-container {
        /* 完美修复多背景参数匹配问题，主图 pcbg 全屏完美遮盖 */
        background:
            url("../../assets/26June/logo.png") right  top  no-repeat,
            url("../../assets/26June/code.png") 50% calc(70% + 10px) no-repeat,
            url("../../assets/26June/pcbg.png")  no-repeat;
        background-size: 110px 35px, 10%,cover;
    }

    /* 头部区域间距优化 */
    .header-section {
        margin-top: 15vh;
        margin-bottom: 30px;
    }

    .year-text {
        font-size: 96px;
        letter-spacing: 8px;
    }

    .brand-name {
        font-size: 46px;
        margin: 16px 0;
    }

    .report-badge {
        font-size: 18px;
        padding: 8px 36px;
        margin: 10px 0 20px 0;
    }

    /* 扫码提示字样 */
    .pc-only-hint {
        display: block;
        margin-top: 15px;
        color: #000; /* 改用青色呼应主体，更具视觉引导 */
        font-size: 15px;
        font-weight: 600;
        letter-spacing: 1.5px;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
    }

    /* 【核心提升】为 PC 端主交互区注入富有空间感的透明磨砂中控舱 */
    .main-content {
        max-width: 460px; /* 适度拉宽 */
        width: 100%;
        margin-top: 0;
        padding: 45px 50px;
        background: rgba(255, 255, 255, 0.06);
        border: 1px solid rgba(255, 255, 255, 0.15);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        border-radius: 28px;
        box-shadow: 
            0 25px 50px -12px rgba(0, 0, 0, 0.5),
            inset 0 1px 1px rgba(255, 255, 255, 0.1);
    }

    .input-group {
        margin-bottom: 30px;
    }

    .job-input {
        font-size: 20px;
        padding: 18px;
        border-radius: 16px;
        background: rgba(15, 23, 42, 0.3); /* PC端采用微深色内嵌框，输入对比更强烈 */
        border-color: rgba(255, 255, 255, 0.2);
    }
    
    .job-input:hover {
        border-color: rgba(0, 191, 165, 0.4);
    }

    .submit-btn {
        font-size: 20px;
        padding: 18px;
        border-radius: 16px;
    }

    /* 优化底部版权页脚在 PC 端的表现 */
    .footer-info {
        bottom: 30px;
        font-size: 13px;
        letter-spacing: 0.5px;
        color: #000;
    }
}
</style>